import { HttpClient } from '@angular/common/http';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

/**
 * Servis za HTTP zahtjeve i upravljanje pretplatama u Angular aplikaciji.
 */
@Injectable({
  providedIn: 'root'
})
export class HttpService {

  private httpClient = inject(HttpClient);
  private destroyRef = inject(DestroyRef);

  /**
   * Izvršava HTTP GET zahtjev na zadani URL.
   * @param url URL na koji se šalje zahtjev.
   * @returns Observable s podacima tipa T.
   */
  get<T>(url: string): Observable<T> {
    return this.httpClient.get<T>(url);
  }

   /**
   * Izvršava HTTP PUT zahtjev na zadani URL.
   *
   * Koristi se za potpuno ažuriranje postojećeg resursa.
   *
   * @param url URL na koji se šalje zahtjev.
   * @param body Podaci koji se šalju u tijelu zahtjeva.
   * @returns Observable s odgovorom tipa T.
   */
  put<T>(url: string, body: any): Observable<T> {
    return this.httpClient.put<T>(url, body);
  }

  /**
   * Izvršava HTTP PATCH zahtjev na zadani URL.
   *
   * Koristi se za djelomično ažuriranje postojećeg resursa.
   *
   * @param url URL na koji se šalje zahtjev.
   * @param body Podaci koji se šalju u tijelu zahtjeva.
   * @returns Observable s odgovorom tipa T.
   */
  patch<T>(url: string, body: any): Observable<T> {
    return this.httpClient.patch<T>(url, body);
  }

  /**
   * Izvršava HTTP DELETE zahtjev na zadani URL.
   *
   * Koristi se za brisanje resursa na poslužitelju.
   *
   * @param url URL na koji se šalje zahtjev.
   * @returns Observable s odgovorom tipa T.
   */
  delete<T>(url: string): Observable<T> {
    return this.httpClient.delete<T>(url);
  }

  /**
   * Izvršava HTTP POST zahtjev na zadani URL.
   * Koristi se za stvaranje novog resursa na poslužitelju.
   * @param url URL na koji se šalje zahtjev.
   * @param body Podaci koji se šalju u tijelu zahtjeva.
   * @returns Observable s odgovorom tipa T.
   */
  post<T>(url: string, body: any): Observable<T> {
    return this.httpClient.post<T>(url, body);
  }

  /**
   * Automatski odjavljuje (unsubscribe) pretplatu kada se komponenta uništi.
   * @param subscription Pretplata koju treba odjaviti.
   */
  unsubscribeWithDestroyRef(subscription: Subscription){
    this.destroyRef.onDestroy(() => {
      subscription.unsubscribe();
    });
  }
}
